<p-panel
    [header]="props?.label"
    [toggleable]="true"
    toggler="header"
    [collapsed]="props?.attributes?.isOpen == 0 ? true : false"
>
    <ng-container #fieldComponent></ng-container>
</p-panel>
